<template>
    <b-modal
            :id="modalId"
            :visible="show"
            @hidden="hideEvents"
            title="Update property status"
    >
        <vue-element-loading :active="loading" :is-full-screen="false"/>
        <b-form-group
                label="Select a property status:"
                label-size="sm"
        >
            <multiselect
                    :options="form.propertyStatusId.options"
                    v-model="form.propertyStatusId.value"
                    label="status"
                    track-by="status"
                    placeholder="Choose a property status"
                    :multiple="false"
                    :hide-selected="true"
                    selectLabel=""
                    tagPlaceholder=" "
                    deselectLabel=""
            >
            <template #caret="{ toggle }">
                <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
            </template>
            </multiselect>
        </b-form-group>
        <template slot="modal-footer">
            <b-button
                    @click="hideModal"
                    variant="outline-secondary">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                :disabled="disabled"
                @click="update"
                class="btn-arrow"
                variant="primary"
            >
                Update properties
                <font-awesome-icon
                        :icon="['far', 'arrow-right']">
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import CaretIcon from '@/components/Form/CaretIcon';
import ModalMixin from '@/components/Modal/ModalMixin';
import Property from '@/services/Property/Property';
import PropertyStatus from '@/services/Property/PropertyStatus';

export default {
  name: 'Update-Status-Modal',
  components: {
    CaretIcon,
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'updateStatusModal',
      loading: false,
      form: {
        propertyStatusId: {
          options: [],
          value: null,
        },
      },
    };
  },
  computed: {
    disabled() {
      return this.form.propertyStatusId.value === null;
    },
  },
  created() {
    this.getPropertyStatuses();
  },
  methods: {
    async getPropertyStatuses() {
      this.loading = true;
      try {
          const { data } = await PropertyStatus.list();
          this.form.propertyStatusId.options = data.data;
      } finally {
        this.loading = false;
      }
    },

    async update() {
      this.loading = true;

      const params = {
        propertyIds: this.nodeIds,
        propertyStatusId: this.form.propertyStatusId.value.propertyStatusId,
      };

      try {
        const { data } = await Property.updateStatus(params);

        const title = 'Properties updated';
        const text = `All ${this.nodeIds.length} properties have been updated`;
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.$emit('refresh-all');
        this.hideModal();
      } catch (e) {

      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
</style>
